
import { Component, Vue, Prop, Model } from "vue-property-decorator";
import { Stage } from '@/types/componentTypes/StepperComponentTypes';

@Component
export default class MapConversion extends Vue {

    @Prop({ default: () => [], type: Array }) steps: Stage[];
    @Model('change', { type: Number, default: 1 }) readonly currentStep!: number;


	private stages: Stage[] = [
		{
			stage: 1,
			title: 'Upload an image'
		},
		{
			stage: 2,
			title: 'Map items'
		},
		{
			stage: 3,
			title: 'Review and confirm'
		}
	];
	
	private get currentSelectedStage(): Stage {
		return this.stages.find(x => x.stage == this.currentStep);
    }
}
